import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';


import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import blue from '@material-ui/core/colors/blue'
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Avatar from '@material-ui/core/Avatar';



const useStyles = makeStyles(theme => ({
  card: {
    maxWidth: 345
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: blue[500],
  },
}));

export default function TourismEvent(props) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardHeader
        title={props.title}
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            {props.type[0]}
          </Avatar>
        }
        subheader={props.link}
      />
      <CardMedia
        className={classes.media}
        
        image={props.image}
      />
      <CardContent>
        <Typography noWrap={true} variant="body2" color="textSecondary" component="p">
          {props.info}
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        <IconButton aria-label="Edit" onClick={props.handleEditButton}>
          <EditIcon />
        </IconButton>
        <IconButton aria-label="Delete" onClick={props.handleDeleteButton}>
          <DeleteIcon />
        </IconButton>
      </CardActions>
    </Card>
  );
}
